import { Component, ViewChild } from '@angular/core';
import { BillNoAndOtpPopupComponent } from '../../../components/subscription/subscription-list/bill-no-and-otp-popup/bill-no-and-otp-popup.component';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SubscriptionListService } from '../../../components/subscription/subscription-list/subscription-list.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-password-verification',
  templateUrl: './password-verification.component.html',
  styleUrls: ['./password-verification.component.scss']
})
export class PasswordVerificationComponent {
  @ViewChild(BillNoAndOtpPopupComponent) billNoAndOtpPopupComponent!:BillNoAndOtpPopupComponent;
  password:any;
  data:any;

  constructor(
    public activeModal: NgbActiveModal,
    public subscriptionListService: SubscriptionListService,
    public toaster:ToastrService
  ) { }

  userForm = {
    password: '',
  };

  save() {
    const data = { password: this.userForm.password }
    this.subscriptionListService.checkPasswordToUpdateDetail(data).subscribe({
      next: (res) => {
        if (res?.isSuccess) {
          if (this.data?.successMessage) {
            this.toaster.success(this.data.successMessage);
          }
          this.activeModal.close(true);
        } else {
          this.toaster.error("Invalid Password!");
        }
      },
      error: (err) => {
        console.error('Error saving:', err);
      }
    });
  }
}
